// @ constants
const actionTypes = require("constants/contactCenter/actionTypes");

// @ commons
const apiURLBuilder = require("core/apiURLBuilder");
const {APIPost} = require("utilities/APIRequestHelper");
const {SECOND_STEP} = require("constants/index");

// @utils
const {formatText} = require("core/i18n").i18n;

//@actions
const signaturePatternActions = require('actions/signaturePattern');

const requestAccessDataInProgress = () => ({
    type: actionTypes.RECOVERY_KEYS_DATA_REQUEST
});

const requestAccessKeyDataError = error => ({
    type: actionTypes.RECOVERY_KEYS_DATA_ERROR,
    payload: {
        error
    }
});

const requestAccessKeyDataFailure = message => ({
    type: actionTypes.RECOVERY_KEYS_DATA_FAILURE,
    payload: {
        message
    }
});

const requestDataReset = () => ({
    type: actionTypes.RECOVERY_KEYS_DATA_RESET
});

const sendKeySMSSuccess = data => ({
    type: actionTypes.RECOVERY_KEY_SUCCESS,
    payload: {
        info: data
    }
});

const requestStepSuccess = step => ({
    type: actionTypes.USER_DATA_SET_STEP,
    payload: {
        step
    }
});

function setVisibleStep(step) {
    return {
        type: actionTypes.RECOVERY_KEYS_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

const errorCodeValidation = error => {
    let message = "";

    switch (error) {
        // description Required field
        case "410002":
            message = formatText("profileKeysLanding-modalBodyRequiredField");
            break;
        // description Codigo OTP Vigente
        case "410071":
            message = formatText("profileKeysLanding-modalBodyOTPCodeValid");
            break;
        // description OTP_NUM_VECES_OTP_GENERADO_SUPERADO
        case "410072":
            message = formatText(
                "profileKeysLanding-modalBodyExceededOTPGenerations"
            );
            break;
        // description OTP_ERR_INTENTOS_OTP_SUPERADO
        case "410080":
            message = formatText(
                "profileKeysLanding-modalBodyOTPExceededCodeIncorrect"
            );
            break;
        // description OTP_ERR_OTP_CADUCADA
        case "410081":
            message = formatText("profileKeysLanding-modalBodyOTPExpired");
            break;
        // description OTP_ERR_OTP_INCORRECTO
        case "410082":
            message = formatText(
                "profileKeysLanding-modalBodyOTPCodeIncorrect"
            );
            break;
        default:
            break;
    }

    return message;
};

const sendKey = code => (dispatch, getState) => {
    const isAlreadyFetching = getState().recoveryKeys.get("isFetching");
    const data = getState().userData.get("data");
    const phoneOTP = data.get("movil");
    const codigo = data.get("persona").get("codigo");
    const TipoOTP = data.get("persona").get("tipo");

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                codigo: codigo,
                codigoOtp: code,
                movil: phoneOTP,
                tipo: TipoOTP
            }
        };
        dispatch(requestAccessDataInProgress());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL("requestKeysSendKey"),
            requestData
        )
            .then(response => dispatch(sendKeySMSSuccess(response)))
            .catch(error => {
                const message = errorCodeValidation(
                    error.error.description[0].codigo
                );
                if (message === "") {
                    dispatch(requestAccessKeyDataError(error.error));
                } else {
                    dispatch(requestAccessKeyDataFailure(message));
                }
            });
    }
};

const sendKeyDisaster = code => (dispatch, getState) => {
    const isAlreadyFetching = getState().recoveryKeys.get("isFetching");
    const data = getState().userData.get("data");
    const phoneOTP = data.get("movil");
    const codigo = data.get("persona").get("codigo");
    const TipoOTP = data.get("persona").get("tipo");
    const tokenCredential = getState().customerFinder.getIn([
        "steps",
        SECOND_STEP,
        "token"
    ]);

    if (!isAlreadyFetching) {
        const params = {
            header: {
                openbankAuthToken: tokenCredential
            },
            query: {
                codigo: codigo,
                codigoOtp: code,
                movil: phoneOTP,
                tipo: TipoOTP
            }
        };
        dispatch(requestAccessDataInProgress());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL("requestKeysSendKey"),
            params
        )
            .then(response => {
                dispatch(sendKeySMSSuccess(response));
                dispatch(requestStepSuccess(3));
            })
            .catch(error => {
                const message = errorCodeValidation(
                    error.error.description[0].codigo
                );

                if (message === "") {
                    dispatch(requestAccessKeyDataError(error.error));
                } else {
                    dispatch(requestAccessKeyDataFailure(message));
                }
            });
    }
};

const KeyDataReset = () => dispatch => {
    dispatch(requestDataReset());
};

const setWizardVisibleStep = step => dispatch => dispatch(setVisibleStep(step));

const validatePatternSignature = () => (dispatch, getState) => {
    const callback = () => dispatch(setWizardVisibleStep(2));
    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};


module.exports = {
    sendKey,
    KeyDataReset,
    sendKeyDisaster,
    setWizardVisibleStep,
    validatePatternSignature
};
